// Third party
import React, { Component } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';

// Components
import EditBenchmarkHolding from './EditBenchmarkHolding';
import ComparisonBaseCell from '../../containers/comparison/ComparisonTable/ComparisonBaseCell';

// Enums
import { userHasPermissionEnabled, PERMISSIONS } from '../../../utils/permissions';
import BenchmarkPortfolio from '@/types/benchmark-portfolio';
import Nullable from '@/types/nullable';
import ComparisonItem from '@/types/comparison-item';
import User from '@/types/user';

type Props = {
  editedBenchmark?: BenchmarkPortfolio;
  user?: Nullable<User>;
  item: ComparisonItem;
  readOnly?: boolean;
  showCurrencies: boolean;
};

class ComparisonBenchmark extends Component<Props> {
  renderHoldings = () => {
    const { user, item, readOnly } = this.props;

    const showCurrencies = !!user && this.props.showCurrencies && userHasPermissionEnabled(user, PERMISSIONS.CURRENCY_CONVERSIONS);

    return (
      <PerfectScrollbar className="benchmark-holdings-container">
        {item.holdings.map(holding => (
          <EditBenchmarkHolding
            readOnly={readOnly}
            holdingCount={item.holdings.length}
            key={holding.id}
            holding={holding}
            showCurrencies={showCurrencies}
            disabled
            showDelete={false}
          />
        ))}
      </PerfectScrollbar>
    );
  };

  render() {
    return (
      <div className="comparison-benchmark">
        <ComparisonBaseCell className="category-header" />
        {this.renderHoldings()}
      </div>
    );
  }
}

export default ComparisonBenchmark;
